import React from 'react';
// import Link from 'material-ui/svg-icons/content/link';
import WordFile from './SVGIcons/WordFile';
import ExcelFile from './SVGIcons/ExcelFile';
import PowerPointFile from './SVGIcons/PowerPointFile';
import ImageFile from './SVGIcons/ImageFile';
import UnkownFile from './SVGIcons/UnkownFile';
import LinkFile from './SVGIcons/LinkFile';
import PdfFile from './SVGIcons/PdfFile';
import ContentIcon from './ContentIcon';

const fileExtMap = {
  image: [
    'jpeg',
    'jpg',
    'png',
    'tiff',
    'eps',
    'indd',
    'ai',
    'svg',
    'psd',
  ],
  pdf: [
    'pdf',
  ],
  excel: [
    'xls',
    'xlsx',
    'xlsm',
    'xlt',
    'xltm',
    'xltx',
    'xla',
    'xlam',
  ],
  word: [
    'doc',
    'dot',
    'docx',
    'docm',
    'dotx',
    'dotm',
    'docb',
  ],
  powerpoint: [
    'ppt',
    'pptx',
    'pptm',
    'potx',
    'ppam',
    'ppsx',
    'ppsm',
    'sldx',
    'sldm',
  ],
};

/**
 * Helper that examines a filename and determines a type by
 * file extenstion
 */
const determineFileType = (title) => {
  const segments = (title || '').split('.');
  const hasFileExtension = segments.length > 1;
  let type;
  if (hasFileExtension) {
    const extension = segments[segments.length - 1];
    Object.keys(fileExtMap)
      .forEach((fileType) => {
        const isCurrentFileType = fileExtMap[fileType].indexOf(extension) > -1;
        if (isCurrentFileType) {
          type = fileType;
        }
      });
  }
  return type;
};

const FileIcon = ({ fileName, isLink, ...props }) => {
  let icon;
  switch (determineFileType(fileName)) {
    case 'image':
      icon = ImageFile;
      break;
    case 'pdf':
      icon = PdfFile;
      break;
    case 'excel':
      icon = ExcelFile;
      break;
    case 'word':
      icon = WordFile;
      break;
    case 'powerpoint':
      icon = PowerPointFile;
      break;
    default:
      icon = UnkownFile;
      break;
  }

  if (isLink) {
    icon = LinkFile;
  }

  return (
    <ContentIcon
      outer={icon}
      {...props}
    />
  );
};

export default FileIcon;
